$(document).ready(function() {
  // Call to calculate values helper
  const callCalculation = (component) => {
    const rawInterest = parseFloat(component.find('.interest-rate--js').val());
    const interestRate = !isNaN(rawInterest) ? rawInterest / 100 : 0.1; // Default to 10%

    const rawDownPayment = parseFloat(component.find('.down-payment-percent--js').val());
    const downPaymentPercent = !isNaN(rawDownPayment) ? rawDownPayment / 100 : 0.2; // Default to 20%

    const rawLoanTerm = parseInt(component.find('.loan-term-years--js').val(), 10);
    const loanTermYears = !isNaN(rawLoanTerm) ? rawLoanTerm : 10; // Default to 10 years

    let paymentsPerYear = parseInt(component.find('.payments-per-year--js').val(), 10);
    paymentsPerYear = !isNaN(paymentsPerYear) ? paymentsPerYear : 12; // Default to 12 (monthly)

    checkAndRunCalculation(interestRate, downPaymentPercent, loanTermYears, paymentsPerYear)
  }

  $(document).on('click', '.clients-momentum-planning-territories-component .toggle-content-btn', function () {
    const territoryQuestions = $(this).closest('.component').find('.toggle-content__questions');
    const territoryCalculator = $(this).closest('.component').find('.toggle-content__calculator');

    if (territoryQuestions.hasClass('d-none')) {
      territoryQuestions.removeClass('d-none');
      territoryCalculator.addClass('d-none');
      $(this).text('Multi-Unit Calculator');
    } else {
      territoryQuestions.addClass('d-none');
      territoryCalculator.removeClass('d-none');
      $(this).text('Back');
      callCalculation($('.brands-unit-calculator-component'));
    }
  });

  // Enter key clicks calculate button
  $(document).on('keydown', '.brands-unit-calculator-component', function(e) {
    if (e.key !== 'Enter') return; // Only run on Enter key
    $(this).find('.calculate-btn').trigger('click');
  })

  // Click calculate button
  $(document).on('click', '.brands-unit-calculator-component .calculate-btn', function(e) {
    callCalculation($('.brands-unit-calculator-component'));
  })

  function checkAndRunCalculation(interestRate, downPaymentPercent, loanTermYears, paymentsPerYear) {
    // If all inputs are filled, calculate the financing
    if (interestRate && downPaymentPercent && loanTermYears && paymentsPerYear) {
      const fees = [
        parseFloat($('.brands-unit-calculator-component .territory-1-fee--js').attr('value')),
        parseFloat($('.brands-unit-calculator-component .territory-2-fee--js').attr('value')),
        parseFloat($('.brands-unit-calculator-component .territory-3-fee--js').attr('value')),
        parseFloat($('.brands-unit-calculator-component .territory-4-fee--js').attr('value'))
      ];

      if (fees.every(Number.isNaN)) return displayNilResults();

      const results = calculateFranchiseFinancing({
        fees,
        downPaymentPercent,
        interestRate,
        loanTermYears,
        paymentsPerYear
      });

      displayTotalFees(results);
      displayAdditionalDownPayments(results);
      displayAdditionalMonthlyPayments(results);
      displayFeeDifference(results);
    }
  }

  function displayNilResults() {
    for (let i = 1; i <= 3; i++) {
      $(`.brands-unit-calculator-component .unit-estimates.territory${i+1} .unit-estimates__category.total-fees .unit-estimates__category__value`).text('--');
      $(`.brands-unit-calculator-component .unit-estimates.territory${i+1} .unit-estimates__category.est-additional-down .unit-estimates__category__value`).text('--');
      $(`.brands-unit-calculator-component .unit-estimates.territory${i+1} .unit-estimates__category.est-additional-payment .unit-estimates__category__value`).text('--');
    }
  }

  function displayTotalFees(results) {
    for (let i = 1; i <= 3; i++) {
      const res = results.totalFees[`territory${i+1}`]
      const amount = Number.isNaN(res) ? '--' : formatCurrency(res); // Handle NaN case

      $(`.brands-unit-calculator-component .unit-estimates.territory${i+1} .unit-estimates__category.total-fees .unit-estimates__category__value`).text(amount);
    }
  }

  function displayAdditionalDownPayments(results) {
    for (let i = 1; i <= 3; i++) {
      const res = results.estAdditionalDown[`territory${i+1}`]
      const amount = Number.isNaN(res) ? '--' : formatCurrency(res); // Handle NaN case

      $(`.brands-unit-calculator-component .unit-estimates.territory${i+1} .unit-estimates__category.est-additional-down .unit-estimates__category__value`).text(amount);
    }
  }

  function displayAdditionalMonthlyPayments(results) {
    for (let i = 1; i <= 3; i++) {
      const res = results.estAdditionalPayment[`territory${i+1}`]
      const amount = Number.isNaN(res) ? '--' : formatCurrency(res); // Handle NaN case

      $(`.brands-unit-calculator-component .unit-estimates.territory${i+1} .unit-estimates__category.est-additional-payment .unit-estimates__category__value`).text(amount);
    }
  }

  function displayFeeDifference(results) {
    for (let i = 1; i <= 3; i++) {
      const res = results.additionalUnitFee[`territory${i+1}`]
      const amount = Number.isNaN(res) ? '--' : formatCurrency(res); // Handle NaN case

      $(`.brands-unit-calculator-component .unit-estimates.territory${i+1} .unit-estimates__category.additional-unit-fee .unit-estimates__category__value`).text(amount);
    }
  }

  function formatCurrency(amount) {
    return amount.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
  }

  function calculateFranchiseFinancing({
                                         fees, // Array of fees: [1 territory, 2, 3, 4]
                                         downPaymentPercent, // Decimal (e.g., 0.2 for 20%)
                                         interestRate, // Annual interest rate as decimal (e.g., 0.08 for 8%)
                                         loanTermYears, // Loan payback period in years
                                         paymentsPerYear // e.g., 12 for monthly
                                       }) {

    const results = {
      totalFees: {},
      estAdditionalDown: {},
      estAdditionalPayment: {},
      additionalUnitFee: {}
    };
    const downPayments = fees.map(fee => fee * downPaymentPercent);
    const loanAmounts = fees.map((fee, i) => fee - downPayments[i]);

    const r = interestRate / paymentsPerYear;
    const n = loanTermYears * paymentsPerYear;

    const monthlyPayments = loanAmounts.map(P =>
      (P * r) / (1 - Math.pow(1 + r, -n))
    );

    for (let i = 1; i <= 3; i++) {
      results.totalFees[`territory${i+1}`] =
        fees[i];
    }

    // Calculate additional down payments
    for (let i = 1; i <= 3; i++) {
      const additional = downPayments[i] - downPayments[0];
      results.estAdditionalDown[`territory${i+1}`] =
        Number(additional.toFixed(2));
    }

    // Calculate additional monthly payments
    for (let i = 1; i <= 3; i++) {
      const additional = monthlyPayments[i] - monthlyPayments[0];
      results.estAdditionalPayment[`territory${i+1}`] =
        Number(additional.toFixed(2));
    }

    // Calculate base fee differences compared to territory 1
    for (let i = 1; i <= 3; i++) {
      const previousFee = fees[i - 1] || 0; // Handle case for territory 1
      const diff = fees[i] - previousFee;
      results.additionalUnitFee[`territory${i + 1}`] = Number(diff.toFixed(2));
    }

    return results;
  }
})

